/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Evgeny Sapozhnikov <evgeny.sapozhnikov@opensoftdev.ru>
 */
define(['assets/js/common/storage/cookie'], function(cookieStorage) {
    return {
        /**
         * @return {Storage}
         */
        getInstance: function() {
            if (this._isStorageAvailable('localStorage')) {
                return localStorage;
            } else {
                return cookieStorage;
            }
        },

        /**
         * @param type
         * @returns {string} {boolean}
         * @private
         */
        _isStorageAvailable: function(type) {
            try {
                var storage = window[type],
                    x = '__storage_test__';
                storage.setItem(x, x);
                storage.removeItem(x);

                return true;
            } catch (e) {
                return (
                    e instanceof DOMException &&
                    // everything except Firefox
                    (e.code === 22 ||
                        // Firefox
                        e.code === 1014 ||
                        // test name field too, because code might not be present
                        // everything except Firefox
                        e.name === 'QuotaExceededError' ||
                        // Firefox
                        e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
                    // acknowledge QuotaExceededError only if there's something already stored
                    storage.length !== 0
                );
            }
        }
    };
});
